@if (data) {
	<section class="container">
		<section class="top-header">
			<h1 class="barlow-condensed">{{ "ShippingHeaderInsert" | translate }}</h1>
			<img src="assets/img/logo_scheu.svg" alt="SCHEU-DENTAL" class="logo" />
		</section>
		<section class="main">
			<h3 class="barlow-condensed">{{ "Product" | translate }}:
				<span [innerHTML]="getProductNameHtml()"></span>
			</h3>
			<p>
				<strong>{{ "Customer" | translate }}:</strong> {{ data.customer.displayName }} -
				<strong>[{{ data.customer.wmsId }}]</strong>
			</p>
			<p>
				<strong>{{ "Patient" | translate }}:</strong>
				{{ data.treatment.patient.displayName }} -
				<strong>[{{ data.treatment.patient.patientId }}]</strong>
			</p>
			<p>
				<strong>{{ "Order" | translate }}#:</strong> {{ data.treatment.quotation.docNum }}
			</p>
			@if (data.treatment.upsPickupReferences?.length > 0) {
				<p>
					<strong>{{ "PickupReference" | translate }}:</strong>
					{{ data.treatment.upsPickupReferences?.at(-1)?.prn }}
				</p>
			}
			<br />
			<p>{{ "ShippingHintInsert" | translate }}</p>
			<hr />
		</section>
		<section class="action-buttons">
			<button mat-raised-button color="primary" (click)="print()">
				{{ "Print" | translate }}
			</button>
			<button mat-raised-button color="primary" mat-dialog-close>{{ 'Close' | translate }}</button>
		</section>
	</section>
}
